import { useCurrency } from '../../../context/CurrencyContext';
import { useLocale } from '../../../context/LocaleContext';
import { CurrencyE } from '../../../declarations/enums/currency';
import SelectDropdown from '../../SelectDropdown/SelectDropdown';
import { ControlsWrapperStyled, HeroWrapperStyled, ImgStyled } from './Hero.styled';

type HeroPropsT = {
  imageUrl: string;
};

export const Hero: React.FC<HeroPropsT> = ({ imageUrl }) => {
  const { langOptions, selectedLocale, onChangeLocale } = useLocale();
  const { selectedCurrency, currencyOptions, onChangeCurrency } = useCurrency();

  return (
    <>
      <HeroWrapperStyled isHeroVisible={!!imageUrl}>
        {!!imageUrl && <ImgStyled src={imageUrl} alt="hero-img" />}

        <ControlsWrapperStyled>
          <SelectDropdown
            isDisabled
            options={currencyOptions}
            value={currencyOptions.find(item => item.value === selectedCurrency)}
            inputIconUrl={'/images/icons/currency/usd.svg'}
            onChange={({ value }) => onChangeCurrency(value as CurrencyE)}
          />

          <SelectDropdown
            isDisabled={langOptions.length <= 1}
            options={langOptions}
            value={langOptions.find(el => el.value === selectedLocale)}
            inputIconUrl={'/images/icons/globe.svg'}
            onChange={({ value }) => onChangeLocale(value)}
          />
        </ControlsWrapperStyled>
      </HeroWrapperStyled>
    </>
  );
};

export default Hero;
